var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3477 12.8517C16.1265 11.3137 17.2681 8.65542 17.6681 6.12042L17.7481 5.57292H20.1552C19.974 8.93875 17.5998 11.7662 14.3477 12.8517ZM14.1461 19.1667H7.85357C9.4844 18.0804 10.4919 16.1763 10.9998 14.9646C11.5065 16.1738 12.5136 18.0796 14.1461 19.1667ZM1.84473 5.57292H4.25181L4.33348 6.12958C4.90556 9.50083 6.19056 11.6329 7.64223 12.8483C4.39514 11.7604 2.02639 8.93542 1.84473 5.57292ZM17.6015 0.833333L16.8444 5.995C16.2865 9.52917 14.2198 13.3333 11.0002 13.3333C7.82315 13.3333 5.77565 9.64542 5.15648 5.99958L4.39898 0.833333H17.6015ZM17.8704 4.73958L18.5654 0H3.43458L4.12958 4.73958H1V5.15625C1 10.0733 5.21167 14.0808 10.4213 14.1625C9.90833 15.5596 8.28208 19.1667 5.16667 19.1667V20H16.8333V19.1667C13.7142 19.1667 12.0879 15.5521 11.5783 14.1625C16.7879 14.0808 21 10.0737 21 5.15625V4.73958H17.8704Z",
    fill: "#252122"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificates);
export default __webpack_public_path__ + "static/media/certificates.c58146f8dde954134c07c0bd5a325948.svg";
export { ForwardRef as ReactComponent };